import React, { useState, useRef, useLayoutEffect } from 'react'
import classnames from 'classnames'

import SelectCar from './car'
import SelectBrand from './brand'
import SelectSeries from './series'
import { sendTeaCommEvent } from 'lib/tea-analyze'

export interface IResult {
  brandId: number
  brandName: string
  seriesId: number
  seriesName: string
  carId: number
  carName: string
  year: number
}

interface IProps {
  className?: string
  onChange: (param: IResult) => void
}

enum Type {
  brand = 0,
  series,
  car,
}
export default function BrandSeriesCarSelector({
  className,
  onChange,
}: IProps) {
  const [state, setState] = useState<Partial<IResult>>()
  const [curr, setCurr] = useState<number>(0)
  // const ref = useRef(null)
  // const top = useRef(139)
  // useLayoutEffect(() => {
  //   console.log(ref.current)
  //   if (ref.current) {
  //     top.current = ref.current.getBoundingClientRect().bottom
  //   }
  // })
  return (
    <div className={classnames(Type[curr], 'selector-container', className)}>
      <h6 className="g-one-line-text">
        {curr >= Type['brand'] && (
          <>
            <span
              onClick={(e) => {
                e.stopPropagation()
                setCurr(Type['brand'])
                sendTeaCommEvent('clk_event', {
                  event_id: 'add_model_module_category',
                  obj_text: state?.brandName || '选择品牌',
                })
              }}
            >
              {state?.brandName || '选择品牌'}
            </span>
            <i className="icon-arrow-ic-r" />
          </>
        )}
        {curr >= Type['series'] && (
          <>
            <span
              onClick={(e) => {
                e.stopPropagation()
                setCurr(Type['series'])
                sendTeaCommEvent('clk_event', {
                  event_id: 'add_model_module_category',
                  obj_text: state?.seriesName || '选择车系',
                })
              }}
            >
              {state?.seriesName || '选择车系'}
            </span>
            <i className="icon-arrow-ic-r" />
          </>
        )}
        {curr >= Type['car'] && (
          <>
            {' '}
            <span>选择车型</span>
            <i className="icon-arrow-ic-r" />
          </>
        )}
      </h6>
      {curr === Type['brand'] && (
        <SelectBrand show={true} onChange={handleBrandChange} />
      )}
      {curr === Type['series'] && state && (
        <SelectSeries
          show={true}
          brandId={state.brandId}
          onChange={handleSeriesChange}
        />
      )}
      {curr === Type['car'] && state && (
        <SelectCar
          show={true}
          seriesId={state.seriesId}
          onChange={handleCarChange}
        />
      )}
      <style jsx>
        {`
          .selector-container {
            position: absolute;
            overflow-y: auto;
            width: calc(100% + 2px);
            border: solid 0.5px rgba(96, 99, 112, 0.4);
            user-select: none;
            background-color: #ffffff;
            height: calc(100vh - 440px);
            min-height: 300px;
            max-height: 712px;
          }
          h6 {
            align-items: center;
            height: 32px;
            line-height: 32px;
            padding: 0 22px 0 12px;
            border-bottom: solid 0.5px rgba(96, 99, 112, 0.4);
            font-size: 14px;
            font-weight: normal;
          }
          h6 i {
            margin-top: -3px;
          }
          .icon-arrow-ic-r {
            font-style: normal;
            margin: 0 8px;
          }
          div :global(.series-selector),
          div :global(.car-selector) {
            position: relative;
            top: 0;
            height: calc(100% - 40px);
            min-height: 60px;
            width: 100%;
            box-shadow: none;
            transition: height 0.13s ease;
          }
          div :global(.brand-selector) {
            position: relative;
            top: 0;
            height: 678px;
            width: 100%;
            box-shadow: none;
            transition: height 0.13s ease;
          }
        `}
      </style>
    </div>
  )

  function handleBrandChange(id: number, name: string) {
    setState({
      brandId: id,
      brandName: name,
    })
    // 展示车系
    setCurr(Type['series'])
    sendTeaCommEvent('clk_event', {
      event_id: 'add_model_module_brand_btn',
      obj_text: name,
    })
  }

  function handleSeriesChange(id: number, name: string) {
    if (!state) {
      return
    }
    setState({
      brandId: state.brandId,
      brandName: state.brandName,
      seriesId: id,
      seriesName: name,
    })
    // 展示车型
    setCurr(Type['car'])
    sendTeaCommEvent('clk_event', {
      event_id: 'add_model_module_series_btn',
      obj_text: name,
    })
  }

  function handleCarChange(
    id: number,
    name: string,
    year: number,
    price: string
  ) {
    if (!state) {
      return
    }
    const newState = {
      ...state,
      carId: id,
      carName: name,
      year,
      price,
    }
    sendTeaCommEvent('clk_event', {
      event_id: 'add_model_module_model_btn',
      obj_text: name,
    })
    setState(newState)
    onChange(newState as IResult)
  }
}
